import { faCalculator, faPencil, faPlus, faTrash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Select from 'react-select';
import { Badge, Button, Col, Container, FormGroup, Input, InputGroup, InputGroupText, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { TradePositionsTable } from '../Screener/Positions';
import { ForexPair } from '../Screener/Screener';
import { CONFIDENCE_LEVEL, STATUS, STATUS_FILTER, STRATEGIES, TIMEFRAME, TradelogContext, VIEWS } from './context';
import DateRangeSlider from './DateRangeSlider';
import OpenTradesChart from './OpenTradesChart';
import SunburstChart from './Sunburts';
import TradeDurationChart from './TradeDurationChart';
import TradeSwiper from './TradeSwiper';
import WaterfallChart from './Waterfall';
var relativeTime = require('dayjs/plugin/relativeTime')
dayjs.extend(relativeTime)

export default function TradeLogindex() {
    const api = useContext(TradelogContext);
    const params = useParams();

    if (params.trade_id) {
        return <>
            <TradeSwiper />
            <UpsertModal />
        </>
    }

    return <div>
        <Container className="pt-5" fluid={api.fullscreen}>
            <div className="d-flex">
                <h3 className="text-white">Trades</h3>
                <div className="ms-auto">
                    {/* {api.fullscreen && <Button className="me-2" size="sm" color="dark" onClick={() => api.setFullscreen(false)}><FontAwesomeIcon icon={faCompressWide} /></Button>} */}
                    {/* {!api.fullscreen && <Button className="me-2" size="sm" color="dark" onClick={() => api.setFullscreen(true)}><FontAwesomeIcon icon={faExpandWide} /> </Button>} */}
                    {/* {api.view === VIEWS.SHOW_ALL && <Button className="me-2" size="sm" color="dark" onClick={() => api.setView(VIEWS.SHOW_PREVIEW)}><FontAwesomeIcon icon={faCaretUp} /></Button>} */}
                    {/* { api.view === VIEWS.SHOW_FIRST_AND_LAST && <Button className="me-2" size="sm" color="dark" onClick={() => api.setView(VIEWS.SHOW_PREVIEW)}><FontAwesomeIcon icon={faList} /></Button>} */}
                    {/* {api.view === VIEWS.SHOW_PREVIEW && <Button className="me-2" size="sm" color="dark" onClick={() => api.setView(VIEWS.SHOW_ALL)}><FontAwesomeIcon icon={faCaretDown} /></Button>} */}
                    <Button size="sm" color="success" onClick={() => api.setUpdateModal(defaultTrade)}><FontAwesomeIcon icon={faPlus} /> Add trade</Button>
                </div>
            </div>
            <Row>
                <Col md="12" lg="6">
                    <DateRangeSlider />
                </Col>

                <Col md="6" lg="2">
                    <FormGroup>
                        <Label className="text-white" >Pair</Label>
                        <div className="text-black">
                            <Select
                                options={api.pairs.map(i => ({ value: i, label: i }))}
                                value={api.filter.pair ? ({ value: api.filter.pair, label: api.filter.pair }) : null}
                                onChange={(value) => api.setFilter(prev => ({ ...prev, pair: value?.value || null }))}
                                placeholder="Pair"
                                isClearable
                            />
                        </div>
                    </FormGroup>

                </Col>
                <Col md="6" lg="2">
                    <FormGroup>
                        <Label className="text-white" >Status</Label>
                        <div className="text-black">
                            <Select
                                options={STATUS_FILTER}
                                value={STATUS_FILTER.find(i => i.value === api.filter.status)}
                                onChange={(value) => api.setFilter(prev => ({ ...prev, status: value?.value || null }))}
                                placeholder="Status"
                                isClearable
                            />
                        </div>
                    </FormGroup>

                </Col>
                <Col md="6" lg="2">
                    <FormGroup>
                        <Label className="text-white" >Strategy</Label>
                        <div className="text-black">
                            <Select
                                options={STRATEGIES}
                                value={STRATEGIES.find(i => i.value === api.filter.strategy)}
                                onChange={(value) => api.setFilter(prev => ({ ...prev, strategy: value?.value || null }))}
                                placeholder="Strategy"
                                isClearable
                            />
                        </div>
                    </FormGroup>

                </Col>
            </Row>
        </Container>
        <Graphs />
        {api.filteredTrades.map((i, index) => <TradeItem key={index} trade={i} />)}
        <UpsertModal />
    </div >
}

export const url = (trade) => `https://www.tradingview.com/chart/YiD4OsYt/?symbol=${trade.exchange}:${trade.pair}&interval=15`


function TradeItem({ trade }) {
    const api = useContext(TradelogContext);
    const [isOpen, setIsOpen] = useState(false)
    const navigate = useNavigate();

    useEffect(() => {
        if (api.view === VIEWS.SHOW_PREVIEW) {
            setIsOpen(false)
        } else {
            setIsOpen(true)
        }
    }, [api.view])


    return <Container fluid={api.fullscreen} className="py-5 border-bottom">
        <Row>
            <Col>
                <div >
                    <div >
                        <Row>
                            <Col md="6">
                                <h4>
                                    <a href={url(trade)} target="_blank" rel="noreferrer" className="no-link">
                                        {trade.exchange}: <ForexPair pair={trade.pair} />
                                    </a>  <StatusBadge status={trade.status} />  <ResultBadge result={trade.result} />
                                </h4>
                                <div className="d-flex">
                                    {trade.strategy && <Badge color="dark" className="me-2">{trade.strategy}</Badge>}
                                    {trade.timeframe && <Badge color="dark" className="me-2">{trade.timeframe}</Badge>}
                                    {trade.confidence && <ConfidenceBadge confidence={trade.confidence} />}
                                    <div className="fw-bold opacity-70 text-white ms-2">{dayjs(trade.open_unix * 1000).format("HH:mm D MMM")}</div>
                                </div>
                            </Col>
                            <Col md="6" className="text-end">
                                <div className="d-flex">

                                    <Button className="ms-auto" color="danger" size="sm" outline onClick={() => api.deleteTrade(trade.trade_id)} ><FontAwesomeIcon icon={faTrash} /> Delete</Button>
                                    {/* {!isOpen && <Button className="ms-3" color="dark" size="sm" onClick={() => setIsOpen(true)} ><FontAwesomeIcon icon={faCaretDown} /></Button>}
                                    {isOpen && <Button className="ms-3" color="dark" size="sm" onClick={() => setIsOpen(false)} ><FontAwesomeIcon icon={faCaretUp} /></Button>} */}
                                    {/* <Button className="ms-3" color="success" size="sm" outline onClick={() => navigate(`/log/trade/${trade.trade_id}`)} ><FontAwesomeIcon icon={faExpandWide} /> Review</Button> */}


                                    <Button className="ms-3" color="success" size="sm" outline onClick={() => api.setUpdateModal(trade)} ><FontAwesomeIcon icon={faPencil} /> Edit</Button>
                                </div>
                            </Col>
                        </Row>
                        {!isOpen && <Row className="pt-3 pointer" >
                            <Col md="2">
                                <TradePositionsTable
                                    closedPositions={api.closedPositions.filter(i => i.trade_id === trade.trade_id)}
                                    openPositions={api.openPositions.filter(i => i.trade_id === trade.trade_id)}
                                />

                            </Col>
                            <Col md="5" className="pb-3 pb-md-0" onClick={() => navigate(`/log/trade/${trade.trade_id}/1`)} >
                                {trade.snapshot_img_src && <SnapshotImg src={trade.snapshot_img_src} />}

                                {(trade.message) && <p className="mb-0 pt-2 text-white">{trade.message}</p>}
                            </Col>
                            <Col md="5" onClick={() => navigate(`/log/trade/${trade.trade_id}/2`)} >
                                {trade.last_snapshot_img_src && <SnapshotImg src={trade.last_snapshot_img_src} />}
                                {(trade.last_message) && <p className="mb-0 pt-2 text-white">{trade.last_message}</p>}
                            </Col>
                        </Row>}
                    </div>
                </div>
            </Col>
        </Row>
    </Container>

}

export const StatusBadge = ({ status, size = "lg", date, close_date }) => {
    const obj = STATUS.find(x => x.value === status)

    const appendDate = () => {
        if (date && close_date) {
            return ` ${date} - ${close_date}`
        }
        if (date) {
            return ` ${date}`
        }
        return ""
    }
    return <Badge size={size} color={obj?.color}>{obj?.label}{appendDate()}</Badge>
}

export const ResultBadge = ({ result, size }) => {
    if (!result) {
        return null
    }
    const treshold = 1.5
    const color = result > treshold ? "success" : result < -1 * treshold ? "danger" : "dark";
    return <Badge pill size={size} color={color} >{result}%</Badge>

}

export const ConfidenceBadge = ({ confidence, size }) => {
    if (!confidence) {
        return null
    }
    return <Badge pill size={size} color={confidence === "High" ? "success" : (confidence === "Low" ? "danger" : "dark")} >{confidence}</Badge>
}
const defaultTrade = {
    snapshot_url: "",
    message: "",
    status: "filled", // win / loss / break-even
    strategy: "mean-reversion",
    timeframe: "15m",
    confidence: "Medium",
    number_of_entries: 1,
    last_snapshot_url: "",
    last_message: "",
    result: null,
    risk_unit: 1000,
}

function UpsertModal() {
    const api = useContext(TradelogContext);

    const setQuery = api.setUpdateModal
    const query = api.updateModal

    // const [query, setQuery] = useState(defaultTrade)

    const onSubmit = () => {
        if(query?.trade_id){
            api.updateTrade(query);
        } else {
            api.createTrade(query);
        }
    }

    const calculateResult = useCallback(async () => {
        if(!query){
            return
        }
        const positions = await api.refreshTradePositions(query.trade_id);
        const new_profit = positions.reduce((acc, i) => acc + i.net_profit, 0)

        if (query.risk_unit > 0 && new_profit) {
            const result = (new_profit / 100) / query.risk_unit * 100;
            setQuery(prev => ({ ...prev, result: result.toFixed(3) }))
        }
    }, [query?.trade_id]);

    return (
        <Modal size="lg" isOpen={api.updateModal} toggle={() => api.setUpdateModal(false)}>
            <ModalHeader toggle={() => api.setCreateModal(false)}>Create trade</ModalHeader>
            <ModalBody>
                <FormGroup>
                    <Label>Snapshot url</Label>
                    <Input type="text" value={query.snapshot_url} onChange={(e) => setQuery(prev => ({ ...prev, snapshot_url: e.target.value }))} />
                </FormGroup>
                <FormGroup>
                    <Label >Status</Label>
                    <div className="-flex">
                    {STATUS.filter(i => i.category !== "closed").map((i, index) => <Button key={index} color={i.color} className="me-1" outline={i.value !== query.status} size="sm" onClick={() => setQuery(prev => ({ ...prev, status: i.value }))}>{i.label}</Button>)}
                    </div>
                </FormGroup>
                <FormGroup>
                    <Label >Strategy</Label>
                    <div className="text-black">
                        <Select
                            options={STRATEGIES}
                            value={STRATEGIES.find(i => i.value === query.strategy)}
                            onChange={(value) => setQuery(prev => ({ ...prev, strategy: value.value }))}
                            placeholder="Strategy"
                        />
                    </div>
                </FormGroup>
                <FormGroup>
                    <Label>Timeframe</Label>
                    <div className="text-black">
                        {TIMEFRAME.map((i, index) => <Button key={index} color="light" className="me-1" outline={i !== query.timeframe} size="sm" onClick={() => setQuery(prev => ({ ...prev, timeframe: i }))}>{i}</Button>)}
                    </div>
                </FormGroup>
                <FormGroup>
                    <Label>Confidence</Label>
                    <div className="text-black">
                        {CONFIDENCE_LEVEL.map((i, index) => <Button key={index} color={i === "High" ? "success" : (i === "Low" ? "danger" : "light")} className="me-1" outline={i !== query.confidence} size="sm" onClick={() => setQuery(prev => ({ ...prev, confidence: i }))}>{i}</Button>)}
                    </div>
                </FormGroup>
                <FormGroup>
                    <Label>Message</Label>
                    <Input type="text" value={query.message} onChange={(e) => setQuery(prev => ({ ...prev, message: e.target.value }))} />
                </FormGroup>
                <FormGroup>
                    <Label >Risk unit</Label>
                    <InputGroup>
                        <Input type="number" step="1" value={query.risk_unit} onChange={(e) => setQuery(prev => ({ ...prev, risk_unit: e.target.value }))} />
                        <InputGroupText>$</InputGroupText>
                    </InputGroup>
                </FormGroup>
                <FormGroup>
                    <Label>Result (GOA)</Label>
                    <InputGroup>
                        <Input type="number" step="1" value={query.result} onChange={(e) => setQuery(prev => ({ ...prev, result: e.target.value }))} />
                        <InputGroupText>%</InputGroupText>
                        <Button color="primary" onClick={async () => await calculateResult()}>
                            <FontAwesomeIcon icon={faCalculator} />
                        </Button>
                    </InputGroup>
                </FormGroup>
                <FormGroup>
                    <Label>Last Snapshot url</Label>
                    <Input type="text" value={query.last_snapshot_url} onChange={(e) => setQuery(prev => ({ ...prev, last_snapshot_url: e.target.value }))} />
                </FormGroup>
                <FormGroup>
                    <Label>Last Message</Label>
                    <Input type="text" value={query.last_message} onChange={(e) => setQuery(prev => ({ ...prev, last_message: e.target.value }))} />
                </FormGroup>
                <FormGroup>
                    <Label>Status</Label>
                    <div className="d-flex">
                        {STATUS.filter(i => i.category === "closed").map((i, index) => <Button key={index} color={i.color} className="me-1" outline={i.value !== query.status} size="sm" onClick={() => setQuery(prev => ({ ...prev, status: i.value }))}>{i.label}</Button>)}
                    </div>
                </FormGroup>
            </ModalBody>
            <ModalFooter>
                <Button color="success" disabled={api.isLoading} onClick={onSubmit}>Submit</Button>
                <Button color="light" disabled={api.isLoading} onClick={() => setQuery(false)}>Cancel</Button>
            </ModalFooter>
        </Modal>
    );
}


export const SnapshotImg = ({ src }) => {
    return <div className="img-container"><img className="" alt="Snapshot" src={src} /></div>
}

function Graphs() {
    const api = useContext(TradelogContext);
    return <Container fluid={api.fullscreen} className="pt-5">
        <Row>
            <Col md="6">
                <SunburstChart />
                <TradeDurationChart />
            </Col>
            <Col md="6">
                <WaterfallChart />
                <OpenTradesChart />
            </Col>
        </Row>
    </Container>
}